import React, { useContext } from 'react';
import { flowRight } from 'lodash';
import { AppContext } from '../../components/app/AppProvider.component';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import {
  ELSPropsFromToastService,
  ELSWithToastService
} from '@els/els-component-toast-react';
import { useHistory } from 'react-router';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import RemediationGoalModal from './RemediationGoalModal.component';
import RemediationQuiz from '../../components/remediation-quiz/RemediationQuiz.component';
import { RoutePath } from '../../components/app/app.constants';
import { RecommendationDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { getQuizTotals } from '../../utilities/remediation.utilities';

type RemediationQuizModalPropsOnly = {
  assessmentGoal: AssessmentGoalDto;
  recommendation: RecommendationDto;
}

export type RemediationQuizModalProps = RemediationQuizModalPropsOnly
  & ELSPropsFromModalService
  & ELSPropsFromToastService;

export const RemediationQuizModalId = 'RemediationQuizModalId';

const RemediationQuizModalComponent = (props: RemediationQuizModalProps) => {

  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;
  const history = useHistory();

  const handleCancelClick = () => {
    props.modalService.closeModal(RemediationQuizModalId);
    history.push(RoutePath.REMEDIATION_STUDENT_HOME);
  };

  const statusCounts = getQuizTotals(baseState);

  return (
    <RemediationGoalModal
      assessmentGoal={props.assessmentGoal}
      handleCancelClick={handleCancelClick}
    >
      <RemediationQuiz
        assessmentGoal={props.assessmentGoal}
        recommendation={props.recommendation}
        metricCounts={statusCounts}
        showReviewQuizButton
        continueQuizzing={false}
        showBorder={false}
      />
    </RemediationGoalModal>
  );
};

const enhance = flowRight(
  ELSWithModalService,
  ELSWithToastService,
);

const RemediationQuizModal = enhance(RemediationQuizModalComponent as unknown as React.FunctionComponent<unknown>) as unknown as React.FC<RemediationQuizModalPropsOnly>;

export default RemediationQuizModal;
